module.exports = __webpack_public_path__ + "static/media/get-started-1-2.3e6cf865.svg";